import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../data/content";

export const FloatingButtons = () => (
  <a
    href={whatsappLink("Hello Faithh! I'd like a free consultation for my business.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chat with Faithh on WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#1faa55] p-4 shadow-[0_12px_40px_-8px_rgba(37,211,102,0.55)] transition-[background-color,transform,box-shadow] duration-400 hover:-translate-y-1 hover:bg-[#25D366]"
  >
    <span aria-hidden="true" className="animate-pulse-ring absolute inset-0 rounded-full bg-[#25D366]/50" />
    <MessageCircle className="relative h-6 w-6 text-white transition-colors duration-300 group-hover:text-navy-950" />
    <span className="relative max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold text-navy-950 opacity-0 transition-[max-width,opacity,margin] duration-500 group-hover:ml-2.5 group-hover:max-w-[140px] group-hover:opacity-100">
      WhatsApp Us
    </span>
  </a>
);
